import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

import { PendingComponent } from '@myn/import-hub/routes';

export const Route = createFileRoute(
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment',
)({
  validateSearch: z.object({
    onlyErrors: z.boolean().prefault(false),
    itemsPerPage: z.number().prefault(50),
  }),
  pendingComponent: PendingComponent,
});
